export default __webpack_public_path__ + "static/media/editIcon.f91bbcf0.svg";